import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, fmtUS, fmtDT } from "@/lib/api";
import { PageHeader, DataTable } from "@/components/common";
import { BackButton } from "@/components/BackButton";

export default function Audit() {
  const [sp] = useSearchParams();
  const pid = sp.get("patient_id");
  const [rows, setRows] = useState([]);
  const [action, setAction] = useState("");
  const [start, setStart] = useState("");
  useEffect(() => {
    api.get("/audit", { params: { ...(action ? { action } : {}), ...(start ? { start } : {}), ...(pid ? { patient_id: pid } : {}), limit: 1000 } }).then((r) => setRows(r.data));
  }, [action, start, pid]);
  const actions = ["", "login", "login_failed", "patient_viewed", "patient_created", "patient_updated", "patient_transferred", "appointment_no_show",
    "patient_archived", "patient_restored", "patient_status_changed", "import_committed", "report_exported", "patients_exported", "user_created", "user_updated", "settings_updated", "role_updated"];
  return (
    <div>
      {pid && <BackButton to={`/patients/${pid}`} label="Back to Patient Profile" testid="audit-back-btn" className="-ml-1.5 mb-1" />}
      <PageHeader title="Audit Logs" subtitle={pid ? "Filtered to one patient record" : "Security and patient record access/modification activity."} />
      <DataTable testid="audit-table" rows={rows} pageSize={50}
        toolbar={<>
          <select className="inp w-56" value={action} onChange={(e) => setAction(e.target.value)} data-testid="audit-action-filter">{actions.map((a) => <option key={a} value={a}>{a || "All actions"}</option>)}</select>
          <input type="date" className="inp w-40" value={start} onChange={(e) => setStart(e.target.value)} data-testid="audit-start-filter" />
        </>}
        columns={[{ key: "at", label: "Time", render: (r) => fmtDT(r.at) }, { key: "user_name", label: "User" }, { key: "action", label: "Action" },
          { key: "entity", label: "Entity" }, { key: "patient_id", label: "Patient Ref", render: (r) => (r.patient_id ? r.patient_id.slice(0, 8) : "—") }, { key: "ip", label: "IP" },
          { key: "details", label: "Details", sortable: false, render: (r) => <span className="block max-w-[320px] truncate text-xs text-[var(--muted-ink)]" title={JSON.stringify(r.details)}>{JSON.stringify(r.details)}</span> }]} />
    </div>
  );
}
